import { availableCode } from "../shared/components/text-blocks/available-content/available-content.component";

export const MarvelChampionsConfiguration = {
  homePage: {
    textSectionTitle: {
      title: "CHOOSE YOUR CHAMPIONS",
      subtitle: "Who will you take into the fight?"
    },
    blockText: {
      heading: "Play Marvel Champions LCG",
      content: [
        "The Vibranium Society is an unofficial fanservice place where you can play Marvel Champions LCG for free."
      ],
      action: "Play"
    },
    cardOutlineDatas: [
      {
        text: {
          heading: "Online tabletop",
          content: [
            `
          You have the full control. Play Marvel Champion online just like in real life. You can drag, add token, draw etc.
        `
          ]
        },
        img:
          "https://raw.githubusercontent.com/thevibraniumsociety/images/master/MC01en_1a.jpg"
      },
      {
        text: {
          heading: "With friends for free",
          content: [
            `
          Create or import your decks, then create a room and play solo or with up to 3 friends. Enjoy it for free !
        `
          ]
        },
        img:
          "https://raw.githubusercontent.com/thevibraniumsociety/images/master/MC01en_187.jpg"
      },
      {
        text: {
          heading: "LOTS OF EXTENSIONS",
          content: [
            `
          Content is regularly updated. Play with the latest extensions. Everything you need to have fun.
        `
          ]
        },
        img:
          "https://raw.githubusercontent.com/thevibraniumsociety/images/master/MC01en_177.jpg"
      }
    ],
    availableContents: [
      { label: "Core Set", availableCode: availableCode.AVAILABLE },
      { label: "The Green Goblin", availableCode: availableCode.NOT_AVAILABLE },
      {
        label: "The Wrecking Crew",
        availableCode: availableCode.NOT_AVAILABLE
      },
      { label: "Captain America", availableCode: availableCode.AVAILABLE },
      { label: "Ms. Marvel", availableCode: availableCode.AVAILABLE },
      { label: "Thor", availableCode: availableCode.AVAILABLE },
      { label: "Black Widow", availableCode: availableCode.AVAILABLE },
      { label: "Doctor Strange", availableCode: availableCode.AVAILABLE },
      { label: "Hulk", availableCode: availableCode.AVAILABLE },
      {
        label: "The Rise of Red Skull",
        availableCode: availableCode.AVAILABLE
      },
      {
        label: "The Once and Future Kang",
        availableCode: availableCode.NOT_AVAILABLE
      },
      { label: "Ant-man", availableCode: availableCode.AVAILABLE },
      { label: "Wasp", availableCode: availableCode.AVAILABLE },
      { label: "Quicksilver", availableCode: availableCode.AVAILABLE },
      { label: "Scarlet Witch", availableCode: availableCode.NOT_AVAILABLE }
    ]
  }
};
